import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { CustomBaseStore, CustomBaseStoreWithShops, OCC_ENDPOINTS } from '@city/const';
import { HTTP_CONTEXT_ENDPOINT } from '@core/const';
import { CustomPointOfService } from '@shop/const';
import { ConverterService, OccEndpointsService } from '@spartacus/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { BASE_STORE_WITH_SHOPS_NORMALIZER } from '../converters';

@Injectable({
  providedIn: 'root',
})
export class OccBaseStoresService {
  constructor(
    private http: HttpClient,
    private occEndpointsService: OccEndpointsService,
    private converterService: ConverterService,
  ) {}

  loadBaseStores(): Observable<CustomBaseStore[]> {
    const url = this.occEndpointsService.buildUrl(OCC_ENDPOINTS.baseStores, {
      queryParams: {
        fields:
          // eslint-disable-next-line max-len
          'code,name,nameDative,nameGenitive,namePrepositional,nameAccusative,nameAblative,cityGeoPoint,cityMapZoom,bonusSystemEnabled,captchaCheckEnabled,isMain,region',
      },
    });

    return this.http
      .get<{ stores: CustomBaseStore[] }>(url, {
        context: new HttpContext().set(HTTP_CONTEXT_ENDPOINT, OCC_ENDPOINTS.baseStores),
      })
      .pipe(map(({ stores }) => stores));
  }

  loadBaseStorePointsOfService(code: string): Observable<CustomPointOfService[]> {
    const url = this.occEndpointsService.buildUrl(OCC_ENDPOINTS.baseStores, {
      queryParams: {
        code,
        fields:
          'code,pointsOfService(name,url,displayName,address(town,postalCode,streetname,streetnumber),openingHours(FULL),geoPoint(FULL))',
      },
    });

    return this.http
      .get<{ stores: CustomBaseStoreWithShops[] }>(url, {
        context: new HttpContext().set(HTTP_CONTEXT_ENDPOINT, OCC_ENDPOINTS.baseStores),
      })
      .pipe(
        map(({ stores }) => stores.find((store) => store.code === code)),
        this.converterService.pipeable(BASE_STORE_WITH_SHOPS_NORMALIZER),
        map((store) => store.pointsOfService || []),
      );
  }
}
